define('SuiteDynamics.PLPThreePanelBanner.Banner',
	[
		'SuiteDynamics.PLPThreePanelBanner.Banner.View'
	],
	function (
		BannerView
	)
{
	'use strict';

	return  {
		mountToApp: function mountToApp (container) {
			var PLP = container.getComponent('PLP');
			if (PLP) {
				PLP.addChildView('ThreePanelBanner', function() {
					return new BannerView({ container: container });
				});
			}
		}
	};
});
